<template>
    <mm-tab-title>
        <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <div>
        <el-form ref="form" :model="result" size="small" label-width="200px">
                <el-form-item label="IP" prop="ip"  required>
                    <el-input placeholder="使用英文逗号隔开，末尾不加逗号" v-model="result.ip"/>
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <el-radio-group v-model="result.status">
                        <el-radio label='active'>active</el-radio>
                        <el-radio label='pause'>pause</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Remark" prop="remark"  >
                    <el-input v-model="result.remark" type="textarea" :rows="5" required/>
                </el-form-item>
        </el-form>

        </div>
    </mm-tab-title>


</template>

<script>
export default {
	data() {
		return {
			result: {
				status: 'active',
			}
		};
	},
	methods: {
		async submit() {
            await this.$validate(this.$refs.form);
            const ip_arr = this.result.ip.split(',');
            const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}$/;
            // console.log(ip_arr);
            for(const ip of ip_arr){
                if(reg.test(ip) === false){
                    this.$message({
                        type: 'error',
                        message: 'ip format error',
                    });
                    return;
                }
            }
			const result = await this.$post('/blackIP/create',this.result);
            this.$router.push({ path: "/blackIpList" });
		}
    },
    beforeMount() {
        const ip = this.$route.query['ip'];
        this.result.ip = ip;
    }
};
</script>